import { createFeature } from '@ngrx/store';
import { headerTasksReducer } from './header-tasks-reducer';

export const headerTasksFeature = createFeature({
  name: 'headerTasks',
  reducer: headerTasksReducer
});
